import { useQuery } from "@apollo/client";
import { Box, Button } from "@mui/material";
import { ReactElement, useState } from "react";

import {
  ListShortCodeOptInKeywordsQuery,
  ListShortCodeOptInKeywordsQueryVariables,
} from "~frontend/__generated__/graphql";
import { AsyncWrapper } from "~frontend/components/AsyncWrapper";
import { FlexBox } from "~frontend/components/FlexBox";
import { PageHeader } from "~frontend/components/PageHeader";
import { TableBox } from "~frontend/components/Table";
import { LIST_SHORT_CODE_OPT_IN_KEYWORDS } from "~frontend/graphql/shortcode";

import CreateKeywordDialog from "./CreateKeywordDialog";
import OptInKeywordsTable from "./OptInKeywordsTable";
import UpdateKeywordDialog from "./UpdateKeywordDialog";
import { ShortcodeOptInKeyword } from "./types";

export default function OptInKeywords({
  shortcodeId,
}: {
  shortcodeId: string;
}): ReactElement {
  const { data, loading, error } = useQuery<
    ListShortCodeOptInKeywordsQuery,
    ListShortCodeOptInKeywordsQueryVariables
  >(LIST_SHORT_CODE_OPT_IN_KEYWORDS, {
    variables: {
      input: {
        shortcodeId,
      },
    },
  });

  const [createKeywordDialogOpen, setCreateKeywordDialogOpen] = useState(false);
  const [editingKeyword, setEditingKeyword] =
    useState<ShortcodeOptInKeyword | null>(null);

  return (
    <Box>
      <PageHeader>
        <FlexBox justifyContent="space-between" alignItems="center">
          <span>Opt In Keywords</span>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setCreateKeywordDialogOpen(true)}
          >
            + New Opt In Keyword
          </Button>
        </FlexBox>
      </PageHeader>
      <AsyncWrapper loading={loading} errors={[error]} data={data}>
        {data => (
          <TableBox>
            <OptInKeywordsTable
              keywords={data.listShortCodeOptInKeywords}
              shortcodeId={shortcodeId}
              openEditDialog={setEditingKeyword}
            />
          </TableBox>
        )}
      </AsyncWrapper>
      <CreateKeywordDialog
        shortcodeId={shortcodeId}
        open={createKeywordDialogOpen}
        onClose={() => setCreateKeywordDialogOpen(false)}
      />
      {editingKeyword ? (
        <UpdateKeywordDialog
          keyword={editingKeyword}
          onClose={() => setEditingKeyword(null)}
        />
      ) : (
        <></>
      )}
    </Box>
  );
}
